module.exports = __webpack_public_path__ + "static/img/laba.9a723c40.svg";